module.exports = __webpack_public_path__ + "img/icon_sm_dbckqr.6f77e3e9.png";